import { useEffect, useState } from "react";
import { getConsent, setConsent } from "../lib/consent";
import {
  initGoogleConsentDefaults,
  loadGoogleAnalytics,
  updateGoogleConsent,
} from "../lib/loadAnalytics";
import CookiePreferencesModal from "./CookiePreferencesModal";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    initGoogleConsentDefaults();

    const consent = getConsent();

    if (!consent) {
      setVisible(true);
      return;
    }

    updateGoogleConsent(consent);

    if (consent.analytics || consent.marketing) {
      loadGoogleAnalytics();
    }
  }, []);

  useEffect(() => {
    const handler = () => setIsModalOpen(true);

    window.addEventListener("open-cookie-preferences", handler);

    return () => {
      window.removeEventListener("open-cookie-preferences", handler);
    };
  }, []);

  const acceptAll = () => {
    const consent = {
      essential: true,
      analytics: true,
      marketing: true,
    };

    setConsent(consent);
    loadGoogleAnalytics();
    updateGoogleConsent(consent);
    setVisible(false);
  };

  const refuseAll = () => {
    const consent = {
      essential: true,
      analytics: false,
      marketing: false,
    };

    setConsent(consent);
    updateGoogleConsent(consent);
    setVisible(false);
  };

  const openPreferences = () => {
    setIsModalOpen(true);
  };

  const closePreferences = () => {
    setIsModalOpen(false);

    const consent = getConsent();
    if (consent) {
      setVisible(false);
    }
  };

  return (
    <>
      {visible && (
        <div className="fixed bottom-4 left-4 right-4 z-50 rounded-2xl bg-white p-4 shadow-2xl md:left-6 md:right-6">
          <h3 className="text-lg font-semibold text-gray-900">Cookies</h3>

          <p className="mt-2 text-sm text-gray-600">
            Nous utilisons des cookies essentiels et, avec votre accord, des cookies
            de mesure d’audience et marketing.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={acceptAll}
              className="rounded-xl bg-black px-4 py-2 text-sm font-medium text-white hover:opacity-90"
            >
              Accepter
            </button>

            <button
              onClick={refuseAll}
              className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
            >
              Refuser
            </button>

            <button
              onClick={openPreferences}
              className="rounded-xl border border-black px-4 py-2 text-sm font-medium text-black hover:bg-gray-100"
            >
              Personnaliser
            </button>
          </div>
        </div>
      )}

      <CookiePreferencesModal
        isOpen={isModalOpen}
        onClose={closePreferences}
      />
    </>
  );
}